var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssistAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_7_2250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#9B7AEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3,
    y: 2.3,
    width: 23.4,
    height: 23.4,
    rx: 11.7,
    stroke: "#9B7AEF",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7154 12.7067C16.7087 12.7335 16.6935 12.7572 16.6723 12.7741C16.651 12.7911 16.6248 12.8003 16.5979 12.8003C16.571 12.8003 16.5448 12.7911 16.5236 12.7741C16.5023 12.7572 16.4871 12.7335 16.4804 12.7067C16.1886 11.6507 15.3777 10.8209 14.351 10.5202C14.325 10.5134 14.3019 10.498 14.2854 10.4763C14.2689 10.4545 14.26 10.4278 14.26 10.4003C14.26 10.3727 14.2689 10.346 14.2854 10.3243C14.3019 10.3025 14.325 10.2871 14.351 10.2804C14.8578 10.1316 15.3193 9.8528 15.6919 9.47018C16.0645 9.08755 16.3359 8.61377 16.4804 8.09358C16.4871 8.06681 16.5023 8.04308 16.5236 8.02614C16.5448 8.0092 16.571 8 16.5979 8C16.6248 8 16.651 8.0092 16.6723 8.02614C16.6935 8.04308 16.7087 8.06681 16.7154 8.09358C17.0072 9.14957 17.8184 9.97947 18.8448 10.2801C18.8709 10.2868 18.8941 10.3022 18.9106 10.324C18.9271 10.3457 18.9361 10.3725 18.9361 10.4001C18.9361 10.4276 18.9271 10.4544 18.9106 10.4762C18.8941 10.4979 18.8709 10.5134 18.8448 10.52C17.8184 10.8208 17.0072 11.6519 16.7155 12.7066L16.7154 12.7067ZM20.9308 15.0893C20.5507 15.201 20.2045 15.4102 19.925 15.6973C19.6454 15.9843 19.4418 16.3397 19.3332 16.73C19.3073 16.8236 19.183 16.8236 19.1585 16.73C19.0499 16.3397 18.8463 15.9843 18.5667 15.6972C18.2872 15.4101 17.941 15.2009 17.5608 15.0892C17.541 15.0845 17.5234 15.0731 17.5107 15.0568C17.4981 15.0405 17.4912 15.0203 17.4912 14.9995C17.4912 14.9787 17.4981 14.9584 17.5107 14.9422C17.5234 14.9259 17.541 14.9144 17.5608 14.9098C18.3314 14.6863 18.9393 14.0622 19.1585 13.2703C19.1631 13.2501 19.1742 13.232 19.1901 13.2191C19.2059 13.2062 19.2256 13.1992 19.2458 13.1992C19.2661 13.1992 19.2857 13.2062 19.3016 13.2191C19.3175 13.232 19.3286 13.2501 19.3332 13.2703C19.5523 14.0622 20.1603 14.6863 20.9308 14.9098C21.0231 14.9364 21.0231 15.0616 20.9308 15.0893ZM15.8773 16.5809C14.3375 17.0304 13.1214 18.276 12.6845 19.8586C12.6746 19.899 12.6518 19.9349 12.6198 19.9605C12.5878 19.9861 12.5484 20 12.5078 20C12.4673 20 12.4278 19.9861 12.3958 19.9605C12.3638 19.9349 12.3411 19.899 12.3312 19.8586C11.8943 18.2771 10.6806 17.0304 9.13839 16.5809C9.09893 16.571 9.06384 16.5479 9.03874 16.5151C9.01364 16.4824 9 16.4419 9 16.4002C9 16.3586 9.01364 16.3181 9.03874 16.2853C9.06384 16.2526 9.09893 16.2294 9.13839 16.2196C10.6782 15.7711 11.8943 14.5257 12.3312 12.9429C12.3409 12.9023 12.3636 12.8663 12.3956 12.8405C12.4276 12.8147 12.4671 12.8007 12.5078 12.8007C12.5485 12.8007 12.5881 12.8147 12.6201 12.8405C12.6521 12.8663 12.6748 12.9023 12.6845 12.9429C13.1215 14.5231 14.3351 15.7712 15.8773 16.2196C15.9167 16.2294 15.9518 16.2526 15.9769 16.2853C16.002 16.3181 16.0157 16.3586 16.0157 16.4002C16.0157 16.4419 16.002 16.4824 15.9769 16.5151C15.9518 16.5479 15.9167 16.571 15.8773 16.5809Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_7_2250",
    x: 0,
    y: 0.2,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0803076 0 0 0 0 0.34601 0 0 0 0 0.786686 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_2250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_2250",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_7_2250"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.09
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0543472 0 0 0 0 0.219226 0 0 0 0 0.489388 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_7_2250",
    result: "effect3_innerShadow_7_2250"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistAvatar);
export default __webpack_public_path__ + "static/media/assist_avatar.4ed47bda94a808a31dd923a8c18b750e.svg";
export { ForwardRef as ReactComponent };